var _TYPES_COMPONENT_MAP;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import * as constants from './constants';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';

var LabelSpan = function LabelSpan(_ref) {
  var children = _ref.children,
      dataSpec = _ref.dataSpec,
      componentAttrs = _objectWithoutProperties(_ref, ["children", "dataSpec"]);

  var labelDataSpec = 'label-span';

  if (dataSpec) {
    labelDataSpec = dataSpec;
  }

  return React.createElement("span", _extends({}, componentAttrs, {
    "data-spec": labelDataSpec
  }), children);
};

var LabelLabel = function LabelLabel(_ref2) {
  var children = _ref2.children,
      htmlFor = _ref2.htmlFor,
      dataSpec = _ref2.dataSpec,
      componentAttrs = _objectWithoutProperties(_ref2, ["children", "htmlFor", "dataSpec"]);

  var labelDataSpec = 'label-label';

  if (dataSpec) {
    labelDataSpec = dataSpec;
  }

  return React.createElement("label", _extends({}, componentAttrs, {
    htmlFor: htmlFor,
    "data-spec": labelDataSpec
  }), children);
};

var TYPES_COMPONENT_MAP = (_TYPES_COMPONENT_MAP = {}, _defineProperty(_TYPES_COMPONENT_MAP, constants.TYPE_SPAN, LabelSpan), _defineProperty(_TYPES_COMPONENT_MAP, constants.TYPE_LABEL, LabelLabel), _TYPES_COMPONENT_MAP);
/**
 * Class that represents a label for a single or multiple inputs.
 * @extends React.PureComponent
 * @example
 * // <Label htmlFor="my-input" type="span">My Label</Label>
**/

var Label =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Label, _React$PureComponent);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, _getPrototypeOf(Label).apply(this, arguments));
  }

  _createClass(Label, [{
    key: "_getRequiredIndicator",
    value: function _getRequiredIndicator(shouldShowAsStatic) {
      var requiredIndicatorClassName = classNames('eds-label__required-indicator', {
        'eds-text-bs': shouldShowAsStatic,
        'eds-text-bm': !shouldShowAsStatic
      });
      return React.createElement("span", {
        className: requiredIndicatorClassName,
        "data-spec": "required-indicator"
      }, React.createElement("span", null, " *"), React.createElement("span", {
        className: "eds-is-hidden-accessible"
      }, "(", gettext('required'), ")"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          type = _this$props.type,
          required = _this$props.required,
          hidden = _this$props.hidden,
          htmlFor = _this$props.htmlFor,
          shouldShowAsStatic = _this$props.shouldShowAsStatic,
          dataSpec = _this$props['data-spec'],
          extraAttrs = _objectWithoutProperties(_this$props, ["children", "type", "required", "hidden", "htmlFor", "shouldShowAsStatic", "data-spec"]);

      var labelClass = classNames('eds-field-styled__label', {
        'eds-label-primary': !hidden,
        'eds-is-hidden-accessible': hidden,
        'eds-field-styled__label--required': required
      });
      var LabelSubComponent = TYPES_COMPONENT_MAP[type];
      var requiredIndicator;

      if (required) {
        requiredIndicator = this._getRequiredIndicator(shouldShowAsStatic);
      }

      return React.createElement(LabelSubComponent, _extends({
        className: labelClass,
        htmlFor: htmlFor,
        dataSpec: dataSpec
      }, extraAttrs), React.createElement("span", {
        className: "eds-label__content"
      }, children), requiredIndicator);
    }
  }]);

  return Label;
}(React.PureComponent);

_defineProperty(Label, "propTypes", {
  children: PropTypes.node.isRequired,

  /**
   * An id string referencing the input this label pertains to.
   */
  htmlFor: PropTypes.string,

  /**
   * One of 'label' or 'span'.
   */
  type: PropTypes.oneOf(constants.TYPES),

  /**
   * Whether or not the field is required.
   */
  required: PropTypes.bool,

  /**
   * Whether or not the field is hidden.
   */
  hidden: PropTypes.bool,

  /**
   * Identifier for tests
   */
  'data-spec': PropTypes.string,

  /**
  * Static state of the input field
  */
  shouldShowAsStatic: PropTypes.bool
});

_defineProperty(Label, "defaultProps", {
  type: constants.TYPE_LABEL,
  required: false,
  hidden: false
});

export { Label as default };